import { useContext, useState } from 'react';
import { AppModal, VoiceSelect } from '../';
import {
  SkinSelector,
  StyledShopAssetModal,
  ShopAssetInfo,
  ShopAssetDescriptionAndTraits,
  ShopAssetDesciption
} from './ShopAssetModal.styled';
import { AssetView, IconButton, BroadsiderTraits } from '../';
import {
  PopupHeaderStart,
  PopupHeaderEnd,
  PopupHeaderTitle,
  PopupHeader
} from '../PopupHeader/PopupHeader.styled';
import { orderItem } from '../../providers/BasejumpApiProvider';
import { useTokenAuth, useShopItems } from '../../hooks';
import { AppContext } from '../../providers/AppContext';

const MAX_NAME_CHARS = 20;

const cropName = (name, maxChars = MAX_NAME_CHARS) => {
  if (name.length <= maxChars) {
    return name;
  }
  return name.substr(0, maxChars) + '...';
}

const ShopAssetTitle = ({ children, asset }) => {
  const { items } = useShopItems();
  const { setSelectedShopAsset } = useContext(AppContext);
  const options = items.filter(i => i.getName() === asset.getName()).map(i => ({ id: i.getItemId(), name: i.getSkinName() }));
  const selectedIndex = options.findIndex((o) => o.name === asset.getSkinName());
  const onSkinSelected = (item) => {
    const assetToSelect = items.find((i) => i.getItemId() === item.id);
    setSelectedShopAsset(assetToSelect);
  }
  return (
    <PopupHeader>
      <PopupHeaderStart/>
      <PopupHeaderTitle>
        {children}
      </PopupHeaderTitle>
      <PopupHeaderEnd />
      <SkinSelector>
        <VoiceSelect disabled={options.length < 2} options={options} selectedIndex={selectedIndex} onOptionSelected={onSkinSelected} modifyLabel={(label) => cropName(label, 16)}/>
      </SkinSelector>
      <PopupHeaderStart/>
    </PopupHeader>
  );
};

const AssetPreview = ({ asset }) => {
  return (
    <div className='asset-modal-preview-content'>
      <img className='asset-modal-preview-content-bg' src='/assets/item_bg.png'/>
      <div className='asset-modal-preview-image-wrapper'>
        <AssetView asset={asset} />
      </div>
    </div>
  );
};

const ShopAssetModal = ({ asset }) => {
  const { basejumpToken, user } = useTokenAuth();
  const { setSelectedShopAsset, setErrorData } = useContext(AppContext);
  const [buyDisabled, setBuyDisabled] = useState(false);

  const onBuy = async () => {
    setBuyDisabled(true);
    try {
      const res = await orderItem(basejumpToken, asset.getItemId());
      setSelectedShopAsset(null);
      setErrorData({ title: `Order ${res.order_id}`, description: 'Your order has been placed!', isError: false });
    } catch (err) {
      setSelectedShopAsset(null);
      setErrorData({ title: 'Error', description: 'We were not able to place your order!'});
    } finally {
      setBuyDisabled(false);
    }
  }

  const buyLabel = `Buy (${asset.getPrice().pricePoints >= 0 ? (asset.getPrice().pricePoints + ' BONES'): 'Not for sale'})`;

  const traits = asset.getTraits() ? [...asset.getTraits()] : [];
  return (
    <AppModal>
      <StyledShopAssetModal>
        <AssetPreview asset={asset}/>
        <ShopAssetTitle asset={asset}>{cropName(asset.getName())}</ShopAssetTitle>
        <ShopAssetInfo>
          <ShopAssetDescriptionAndTraits>
	    <ShopAssetDesciption>{asset.getDescription()}</ShopAssetDesciption>
            <div className='asset-modal-info-traits'>
              <BroadsiderTraits traits={traits} singleRow={true}/>
            </div>
          </ShopAssetDescriptionAndTraits>
          <IconButton clickSound='buy' disabled={buyDisabled || asset.isLocked() || asset.getPrice().pricePoints < 0 || asset.getPrice().pricePoints > user.points} onClick={onBuy}>{buyLabel}</IconButton>
        </ShopAssetInfo>
      </StyledShopAssetModal>
    </AppModal>
  );
};

export default ShopAssetModal;
